import * as React from 'react';

import {
  PictogramDealAttachedDocuments40,
  PictogramPlaceholderImages40,
  PictogramServicesLegalVerification40,
  PictogramServicesPerson40,
  PictogramValuationPrice40,
} from '@cian/ui-kit-design-tokens/pictograms';

import * as styles from './QuestionsAndAnswersItem.css';

interface IQuestionsAndAnswersItemProps {
  type: 'service' | 'consultant' | 'support' | 'partial' | 'existing';
  question: string;
  answer: string;
}

const ICONS = {
  service: <PictogramValuationPrice40 color="icon-primary-default" />,
  consultant: <PictogramServicesPerson40 color="icon-primary-default" />,
  support: <PictogramDealAttachedDocuments40 color="icon-primary-default" />,
  partial: <PictogramPlaceholderImages40 color="icon-primary-default" />,
  existing: <PictogramServicesLegalVerification40 color="icon-primary-default" />,
};

export const QuestionsAndAnswersItem = ({ type, question, answer }: IQuestionsAndAnswersItemProps) => {
  return (
    <div className={styles['item']}>
      <div className={styles['icon']}>{ICONS[type]}</div>
      <div className={styles['content']}>
        <div className={styles['question']}>{question}</div>
        <div className={styles['answer']}>{answer}</div>
      </div>
    </div>
  );
};
